import React from "react";

export interface IconShareProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconShare: React.FC<IconShareProps> = ({
  width = 32,
  height = 23,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 23"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.6 11.5C12.695 11.5 15.2 8.9279 15.2 5.75C15.2 2.5721 12.695 0 9.6 0C6.505 0 4 2.5721 4 5.75C4 8.9279 6.505 11.5 9.6 11.5ZM13.44 13.1429H13.025C11.985 13.6562 10.83 13.9643 9.6 13.9643C8.37 13.9643 7.22 13.6562 6.175 13.1429H5.76C2.58 13.1429 0 15.792 0 19.0571V20.5357C0 21.8962 1.075 23 2.4 23H16.8C18.125 23 19.2 21.8962 19.2 20.5357V19.0571C19.2 15.792 16.62 13.1429 13.44 13.1429ZM24 11.5C26.65 11.5 28.8 9.29241 28.8 6.57143C28.8 3.85045 26.65 1.64286 24 1.64286C21.35 1.64286 19.2 3.85045 19.2 6.57143C19.2 9.29241 21.35 11.5 24 11.5ZM26.4 13.1429H26.21C25.515 13.3893 24.78 13.5536 24 13.5536C23.22 13.5536 22.485 13.3893 21.79 13.1429H21.6C20.58 13.1429 19.64 13.4458 18.815 13.9335C20.035 15.2837 20.8 17.0754 20.8 19.0571V21.0286C20.8 21.1415 20.775 21.2493 20.77 21.3571H29.6C30.925 21.3571 32 20.2533 32 18.8929C32 15.715 29.495 13.1429 26.4 13.1429Z" />
  </svg>
);
